import { PrivateRoutes } from '@/constants/routes'
import { IAppStore } from '@/models/store.model'
import { webApiService } from '@/services'
import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react'
import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'
import { MdArrowBackIos, MdDone, MdCheckCircle, MdRefresh } from 'react-icons/md'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { useTradeinContext } from '../hooks/useTradeinContext'
import CancelTradein from './CancelTradein'
import CheckFeasibility from './CheckFeasibility'
import Recalculate from './Recalculate'
import ResendCode from './ResendCode'
import { IConfigSeller } from '@/models/configSeller'
import InWarehouse from './InWarehouse'
import ForwardGiftcard from './ForwardGiftcard'
import MultipleReceipt from './MultipleReceipt'
import NUIAlert from '@/components/Alert/Alert'
import AddDocument from './AddDocument'
import moment from 'moment'
import { currencyFormat } from '@/utils/currencyFormat'
import { generateBarcodeBase64 } from '@/utils/makeBarCode.util'
import { Document, Page, pdf } from '@react-pdf/renderer'
import { blobToBase64 } from '@/utils/blobToBase64.util'
import Html from 'react-pdf-html'
import AddContribution from './AddContribution'
import AddPurchaseDevice from './AddPurchaseDevice'

const Header = () => {
  const [data, setData] = useState<{ loading: boolean, open: boolean, rut: string }>({ loading: false, open: false, rut: '' })
  const [isCheckingCode, setIsCheckingCode] = useState<boolean>(false)
  const navigate = useNavigate()
  const { ctx, saveCtx } = useTradeinContext()
  const { id, slug } = useParams()
  const userState = useSelector((store: IAppStore) => store.user)
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isCoppel = configSeller.config.s3.FOLDER_APP === 'ti_coppel'
  const isWom = configSeller.config.s3.FOLDER_APP === 'ti_wom'
  const isXiaomi = configSeller.config.s3.FOLDER_APP === 'ti_xiaomi'
  const isFalabellaPeru = configSeller.config.s3.FOLDER_APP === 'ti_falabella_pe'
  const isFalabellaChile = configSeller.config.s3.FOLDER_APP === 'ti_falabella'
  // const isNovabench = import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== '' && import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== undefined && import.meta.env.VITE_ID_STORE_REMOVECHECKLIST.split(',').includes(String(userState.id_store)) && isFalabellaChile && ctx.tradein.sbu === 'Notebook'
  const isMacstoreMexico = configSeller.config.s3.FOLDER_APP === 'ti_macstore'
  const isSamsungMexico = configSeller.config.s3.FOLDER_APP === 'ti_samsung_mx'
  const allowedEmails = (import.meta.env.VITE_CAN_CANCEL_TRADEIN || '')
    .split(',')
    .map((email: string) => email.trim())
  const [loading, setLoading] = useState(false)
  console.log('loading', loading)

  const handleRut = () => {
    setData({ ...data, open: true })
  }

  const handleClose = () => {
    setData({ ...data, open: false })
  }

  const handleRecibir = () => {
    setData({ ...data, loading: true })
    webApiService.update({
      id_tradein: String(id),
      id_user: userState.id,
      stage: 6,
      id_role: userState.id_role,
      email: userState.email,
      client_email: ctx.tradein.email,
      id_seller: ctx.tradein.id_seller,
      rut: data.rut,
      client_name: ctx.tradein.name,
      url_contract: ctx.tradein.url_contract,
      recipient_name: ctx.tradein.recipient_name,
      recipient_lastname: ctx.tradein.recipient_lastname,
      recipient_rut: ctx.tradein.recipient_rut
    })
      .then((data) => {
        if (data.data.folio && configSeller.config.s3.FOLDER_APP === 'ti_falabella_pe') {
          updateContract(data.data)
        } else {
          enqueueSnackbar('Estado actualizado a Entregado', { variant: 'success' })
          setData({ ...data, loading: false, rut: '' })
          console.log('data', data)
          saveCtx({ ...ctx, reload: true })
        }
      })
      .catch((error: any) => {
        if (error.status === 500 && error.response.data !== undefined) {
          enqueueSnackbar(error.response.data.message, { variant: 'error' })
          enqueueSnackbar('Recargando pagina', { variant: 'warning' })
          saveCtx({ ...ctx, reload: true })
        } else {
          enqueueSnackbar(error.message, { variant: 'error' })
        }

        setData({ ...data, loading: false, rut: '' })
        console.log('error ==>', error)
      })
  }

  const updateContract = async (data: any) => {
    const fecha = moment().locale('es').format('DD/MM/YYYY')
    const fullname = String(ctx.tradein.name) + ' ' + String(ctx.tradein.lastname)
    const identificacion: string = ctx.tradein.rut
    const marca: string = ctx.tradein.brand
    const modelo: string = ctx.tradein.model
    const imei: string = ctx.tradein.serie
    const discount = currencyFormat(Number(ctx.tradein.discount_amount), import.meta.env.VITE_COUNTRY)
    const address: string = ctx.tradein.address + ', ' + ctx.tradein.city
    const sbu: string = ctx.tradein.sbu
    const civilState: string = String(ctx.tradein.civil_state)
    const barCodeText1 = data.folio
    const barCodeText2 = String(ctx.tradein.discount_amount)
    console.log('barCodeText1 ==> ', barCodeText1)

    const urlFirma = `https://${import.meta.env.VITE_BUCKET}.s3.us-west-2.amazonaws.com/${configSeller.config.s3.FOLDER_APP}/contratos/${ctx.tradein.id}/${data.contractName.replace('contrato.pdf', 'Signature.png')}`
    console.log('urlFirma ==> ', urlFirma)

    const htmlWidthReplace = configSeller.config.html.replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{identificacion}}', identificacion)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{imei}}', imei)
      .replaceAll('{{discount}}', discount)
      .replaceAll('{{domicilio}}', address)
      .replaceAll('{{sbu}}', sbu)
      .replaceAll('{{estadoCivil}}', civilState)
      .replace('{{barCode1}}', '<img width="250px" src="' + String(generateBarcodeBase64(barCodeText1)) + '">')
      .replace('{{barCode2}}', '<img width="250px" src="' + String(generateBarcodeBase64(barCodeText2)) + '">')
      .replace('{{firma}}', '<img style="height:80px" src="' + urlFirma + '">')

    console.log('htmlWidthReplace ==> ', htmlWidthReplace)

    // convertir el html a pdf
    const pdfBlobMacstore = await pdf(<Document> <Page size='A4' style={{ fontFamily: 'Helvetica', fontWeight: 'bold' }}> <Html style={{ margin: '40px' }} resetStyles={false}>{htmlWidthReplace.replaceAll(/Times New Roman/gi, 'Helvetica')}</Html> </Page></Document>).toBlob()
    console.log('🚀 ~ pdfBlobMacstore:', pdfBlobMacstore)
    const pdfWidthFolio = await blobToBase64(pdfBlobMacstore)
    console.log('🚀 ~ pdfWidthFolio:', pdfWidthFolio)

    await webApiService.updateContract({ pdf: pdfWidthFolio, seller: slug, id_tradein: ctx.tradein.id, contractName: data.contractName, name: fullname, email: ctx.tradein.email }).then(res => {
      console.log('🚀 ~ awaitwebApiService.signContract ~ res:', res)
      enqueueSnackbar('Estado actualizado a Entregado', { variant: 'success' })
      setData({ ...data, loading: false, rut: '' })
      console.log('data', data)
      saveCtx({ ...ctx, reload: true })
    }).catch((error : any) => {
      console.log('🚀 ~ awaitwebApiService.signContract ~ error:', error)
      enqueueSnackbar('Error al firmar', { variant: 'error' })
      setData({ ...data, loading: false })
    })

    // Download PDF pdfBlobMacstore
  }

  const checkLoginCode = async () => {
    setIsCheckingCode(true)
    const obj = {
      idTradein: ctx.tradein.id,
      loginCode: ctx.tradein.login_code
    }
    console.log('obj => ', obj)

    try {
      const res = await webApiService.checkLoginCode(obj)
      console.log('res => ', res)
      setIsCheckingCode(false)
      if (res.success) {
        enqueueSnackbar(res.message, { variant: 'success' })
        saveCtx({ ...ctx, reload: true })
      } else {
        enqueueSnackbar(res.message, { variant: 'info' })
      }
    } catch (error) {
      console.log('error => ', error)
      enqueueSnackbar('Error al verificar el código. Por favor, vuelva a intentar.', { variant: 'error' })
      setIsCheckingCode(false)
    }
  }

  const handleSerieSave = async () => {
    setLoading(true)
    if (import.meta.env.VITE_COUNTRY === 'CL') {
      await webApiService.checkTestCL(String(ctx.tradein.login_code_novabench), String(ctx.tradein.id)).then((res) => {
        console.log('res', res)
      }).then(() => {
        // enqueueSnackbar('Revision Novabench exitosa', { variant: 'success' })
      })
        .catch((error) => {
          enqueueSnackbar('Hubo un error al intentar revisar Novabench.', { variant: 'error' })
          console.log('error ==>', error)
        }).finally(() => {
          saveCtx({ ...ctx, reload: true })
          setLoading(false)
        })
    }
    if (import.meta.env.VITE_COUNTRY === 'MX') {
      await webApiService.checkTestMX(String(ctx.tradein.login_code_novabench), String(ctx.tradein.id)).then((res) => {
        console.log('res', res)
      })
        .then(() => {
          // enqueueSnackbar('Cons', { variant: 'success' })
        })
        .catch((error) => {
          enqueueSnackbar('Hubo un error al intentar revisar Novabench.', { variant: 'error' })
          console.log('error ==>', error)
        }).finally(() => {
          saveCtx({ ...ctx, reload: true })
          setLoading(false)
        })
    }
    // webApiService.update({ stage: 7, id: ctx.tradein.id, serie, id_seller: ctx.tradein.id_seller })
    //   .then(() => {
    //     enqueueSnackbar('Se actualizó el número de IMEI/serie.', { variant: 'success' })
    //   })
    //   .catch((error) => {
    //     enqueueSnackbar('Hubo un error al intentar guardar el número de IMEI/serie.', { variant: 'error' })
    //     console.log('error ==>', error)
    //   }).finally(() => {
    //     saveCtx({ ...ctx, reload: true })
    //     setLoading(false)
    //   })
  }
  return (
    <div className='grid grid-cols-2'>
      <div className='flex items-center'>
        <Button
          variant='ghost' size='sm' color='primary' onClick={() => navigate(PrivateRoutes.HOME.replace(':slug', String(slug)))} startContent={
            <MdArrowBackIos className='text-black/50 mb-0.5 dark:text-white/90 text-slate-400 pointer-events-none flex-shrink-0' />
        }
        >Volver
        </Button>
        <h1 className='font-black md:text-2xl ml-2'>{ctx.tradein.brand + ' - ' + ctx.tradein.model}</h1>
      </div>
      <div className='flex justify-end'>
        <AddContribution />
        {(ctx.tradein.sbu === 'Smartphone' && ctx.tradein.id_status === 6 && ![Number(import.meta.env.VITE_PERFIL_SOLOLECTURA)].includes(userState.id_role))
          ? (
            <ResendCode />
            )
          : null}
        {isCoppel && ctx.tradein.rut !== '' && ctx.tradein.id_status === 3 && ![Number(import.meta.env.VITE_PERFIL_SOLOLECTURA), Number(import.meta.env.VITE_PERFIL_TI_COTIZADOR)].includes(userState.id_role) ? <MultipleReceipt /> : null}
        {
        (
          (
            !isFalabellaPeru &&
            (ctx.tradein.id_status === 3 || (ctx.displayContract === 0 && ctx.tradein.id_status === 4)) &&
            ctx.tradein.hasFiles === 1 &&
            ![Number(import.meta.env.VITE_PERFIL_SOLOLECTURA), Number(import.meta.env.VITE_PERFIL_TI_COTIZADOR)].includes(userState.id_role)
          ) ||
          (
            isFalabellaPeru &&
            (ctx.tradein.id_status === 3 || (ctx.displayContract === 0 && ctx.tradein.id_status === 4)) &&
            ctx.tradein.hasFiles === 1 &&
            ![Number(import.meta.env.VITE_PERFIL_SOLOLECTURA), Number(import.meta.env.VITE_PERFIL_TI_COTIZADOR), Number(import.meta.env.VITE_PERFIL_EJECUTIVO)].includes(userState.id_role)
          )
        )
          ? (
            <>
              <Button
                color='primary'
                variant='shadow'
                size='sm'
                style={{ marginLeft: '5px' }}
                endContent={<MdDone style={{ fontSize: '15px' }} />}
                onClick={String(configSeller.config.s3.FOLDER_APP) === 'ti_falabella' || String(configSeller.config.s3.FOLDER_APP) === 'ti_macstore' || String(configSeller.config.s3.FOLDER_APP) === 'ti_wom' || String(configSeller.config.s3.FOLDER_APP) === 'ti_oppo' || String(configSeller.config.s3.FOLDER_APP) === 'ti_samsung_pe_rom' || String(configSeller.config.s3.FOLDER_APP) === 'ti_conecta_peru' ? handleRut : handleRecibir}
                isLoading={data.loading}
              >
                {(String(configSeller.config.s3.FOLDER_APP) === 'ti_falabella' || String(configSeller.config.s3.FOLDER_APP) === 'ti_conecta_peru') ? 'Recibir y emitir giftcard' : 'Recibir equipo'}
              </Button>
              <Modal backdrop='blur' isOpen={data.open} onClose={handleClose}>
                <ModalContent>
                  <ModalHeader className='flex flex-col gap-1'>Datos Receptor</ModalHeader>
                  <ModalBody>
                    <NUIAlert type='warning'>¿El cliente te ha entregado el dispositivo restablecido y desvinculado?</NUIAlert>
                    <div>
                      <Input
                        type='text'
                        variant='bordered'
                        label='Nombre del receptor'
                        value={ctx.tradein.recipient_name}
                        fullWidth
                  // errorMessage={ctx.validation && ctx.data.name.trim() === '' ? 'Debe ingresar su nombre' : ''}
                  // isInvalid={ctx.validation && ctx.data.name.trim() === ''}
                        autoComplete='off'
                        onChange={(e) => saveCtx({ ...ctx, tradein: { ...ctx.tradein, recipient_name: e.target.value } })}
                      />
                    </div>
                    <div>
                      <Input
                        type='text'
                        variant='bordered'
                        label='Apellido del receptor'
                        value={ctx.tradein.recipient_lastname}
                        fullWidth
                  // errorMessage={ctx.validation && ctx.data.lastname.trim() === '' ? 'Debe ingresar su apellido' : ''}
                  // isInvalid={ctx.validation && ctx.data.lastname.trim() === ''}
                        autoComplete='off'
                        onChange={(e) => saveCtx({ ...ctx, tradein: { ...ctx.tradein, recipient_lastname: e.target.value } })}
                      />
                    </div>
                    <div className='col-span-2'>
                      <Input
                        type='text'
                        variant='bordered'
                        label={`${import.meta.env.VITE_LABEL_RUT} del receptor`}
                        value={ctx.tradein.recipient_rut}
                        fullWidth
                  // errorMessage={ctx.validation && ctx.data.lastname.trim() === '' ? 'Debe ingresar su apellido' : ''}
                  // isInvalid={ctx.validation && ctx.data.lastname.trim() === ''}
                        autoComplete='off'
                        onChange={(e) => saveCtx({ ...ctx, tradein: { ...ctx.tradein, recipient_rut: e.target.value } })}
                      />
                    </div>
                    <p hidden={String(configSeller.config.s3.FOLDER_APP) !== 'ti_falabella'}>Si aprietas "Ok" se emitirá la Gift Card</p>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color='danger'
                      onClick={handleClose}
                    >
                      Cerrar
                    </Button>
                    <Button color='primary' type='submit' onClick={handleRecibir} isDisabled={ctx.tradein.recipient_name === '' || ctx.tradein.recipient_name === undefined || ctx.tradein.recipient_lastname === '' || ctx.tradein.recipient_lastname === undefined || ctx.tradein.recipient_rut === '' || ctx.tradein.recipient_rut === undefined} isLoading={data.loading}>
                      {data.loading ? 'Enviando...' : 'Ok'}
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
            </>
            )
          : null
}

        {(ctx.tradein.recalculate === '1' && ctx.tradein.wasRecalculated === null && ctx.tradein.id_status !== 8 && ![Number(import.meta.env.VITE_PERFIL_SOLOLECTURA)].includes(userState.id_role))
          ? (
            <Recalculate />
            )
          : null}
        {
            ctx.tradein.certificate_theft === 'VALID' && ctx.tradein.cancel_reason === 'El modelo evaluado no esta disponible' && ctx.tradein.grade_IA === null && ctx.tradein.id_status === 8 && (ctx.tradein.sbu === 'Smartphone' || ctx.tradein.sbu === 'Tablet') && ![Number(import.meta.env.VITE_PERFIL_SOLOLECTURA)].includes(userState.id_role)
              ? (
                <CheckFeasibility />
                )
              : null
          }
        {ctx.tradein.id_status === 4 && ![Number(import.meta.env.VITE_PERFIL_SOLOLECTURA)].includes(userState.id_role) && configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe'
          ? (
            <InWarehouse />
            )
          : null}
        {
            configSeller.config.s3.FOLDER_APP === 'ti_falabella' && [5, 7, 9].includes(ctx.tradein.id_status)
              ? (
                <ForwardGiftcard />
                )
              : null
          }
        {import.meta.env.VITE_COUNTRY === 'CL' && ctx.tradein.id_status === 1 && ctx.tradein.id_seller === 3 && (ctx.tradein.id_sbu === 1 || (ctx.tradein.id_sbu === 3 && ctx.tradein.brand === 'Apple')) &&
          <Button variant='shadow' size='sm' color='primary' onClick={checkLoginCode} isLoading={isCheckingCode}>
            Verificar Código
            <MdCheckCircle />
          </Button>}
        {((isFalabellaChile || isMacstoreMexico) && [1].includes(ctx.tradein.id_status) && ctx.tradein.sbu === 'Notebook') &&
          <Button
            variant='shadow'
            color='secondary'
            size='sm'
            endContent={<MdRefresh />}
            onClick={() => handleSerieSave()}
            isLoading={loading}
            disabled={loading}
          >
            Revisar Novabench
          </Button>}
        {(ctx.tradein.id_status < 5 && ![Number(import.meta.env.VITE_PERFIL_SOLOLECTURA)].includes(userState.id_role)) || (ctx.tradein.id_status < 8 && allowedEmails.includes(userState.email))
          ? (
            <CancelTradein />
            )
          : null}
        {ctx.tradein.id_status >= 5 && ![Number(import.meta.env.VITE_PERFIL_SOLOLECTURA)].includes(userState.id_role) && ctx.tradein.document_cupon_used === null && (isWom || isXiaomi)
          ? (
            <AddDocument />
            )
          : null}

        {ctx.tradein.id_status >= 5 && ![Number(import.meta.env.VITE_PERFIL_SOLOLECTURA)].includes(userState.id_role) && ctx.tradein.device_purchased === null && (isSamsungMexico)
          ? (
            <AddPurchaseDevice />
            )
          : null}

      </div>
    </div>
  )
}

export default Header
